
import Component, { mixins } from "vue-class-component";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import { ProxyTableData } from "@/UI/components/Helpers/ProxyTableData";
import { SalaryCalculationsTable } from "@/UI/pages/SalaryСalculations/lib/table";
import { RouterNameEnum } from "@/router/router.types";
import ModalPayrollAccounting from "@/UI/pages/SalaryСalculations/Components/ModalPayrollAccounting.vue"
import ModalFinanceOperations from "@/UI/pages/SalaryСalculations/Components/ModalFinanceOperations.vue"
import SettlementsComponents from "@/UI/pages/SalaryСalculations/Components/SettlementsComponent.vue"

@Component({
    components: {
        PageTitle,
        BaseDataForm,
        ModalPayrollAccounting,
        ModalFinanceOperations,
        SettlementsComponents
    }
})

export default class ClientAccount extends mixins(
    ProxyTableData,
    SalaryCalculationsTable
) {
    data: any = []
    showModal = false
    RouterNames = RouterNameEnum;
    form = []
    title: string = ''
    mod: number = 0

    openPayrollAccounting() {
        this.mod = 1
        this.title = 'Новый расчет зарплаты'
        this.showModal = true
    }
    openFinanceOperations() {
        this.mod = 2
        this.title = 'Финансовые операции'
        this.showModal = true
    }

    async created() {
        for(let i = 0; i < 30; i++ ) {
            this.data.push({
                key0: '10.09.1983',
                key1: 'Расчет и начесление',
                key2: '800',
                key3: '100',
                key4: '3421',
            })
        }
        this.formReady = true
    }
}
